// video.jsとvideojs-hotkeysのESModuleインポート
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-hotkeys';

// グローバル変数として設定（既存のコードとの互換性のため）
declare global {
  interface Window {
    videojs: any;
  }
}

// グローバル変数に設定
window.videojs = videojs;

export default videojs; 